import React from 'react';
import { useCart } from '../context/CartContext';

// Placeholder Cart Icons (replace with actual icons or an icon library if desired)
const CartIconEmpty = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7 text-gray-900 hover:text-black">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
  </svg>
);

const CartIconFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7 text-indigo-800 hover:text-indigo-900">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
  </svg>
);

const Header = ({ onToggleCart }) => {
  const { cartItems } = useCart();
  const itemCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <header className="py-2 sm:py-3 sticky top-0 z-40">
      <div className="container mx-auto px-4 flex justify-between items-center">
        {/* Adjusted spacer to match cart icon size potentially if needed, or keep as is for balance */}
        <div className="w-10 h-10 sm:w-12 sm:h-12 flex-shrink-0"></div> 

        <div className="flex-grow text-center">
          <img 
            src="/logo.png" 
            alt="Canary Store Logo" 
            // Increased max-w further, e.g., targetting ~20vw for medium screens
            className="max-w-[25vw] sm:max-w-[20vw] md:max-w-[15vw] lg:max-w-[12vw] h-auto inline-block"
          />
        </div>

        <button 
          onClick={onToggleCart} 
          className="relative p-2 rounded-full bg-white/50 hover:bg-white/70 backdrop-blur-sm hover:backdrop-blur-md transition-all duration-200 flex-shrink-0"
          aria-label={itemCount > 0 ? `Open cart (${itemCount} items)` : "Open cart (empty)"}
        >
          {itemCount > 0 ? <CartIconFilled /> : <CartIconEmpty />}
          {itemCount > 0 && (
            <span className="absolute top-0 right-0 block h-5 w-5 transform -translate-y-1/2 translate-x-1/2 rounded-full bg-red-500 text-white text-xs flex items-center justify-center shadow">
              {itemCount}
            </span>
          )}
        </button>
      </div>
    </header>
  );
};

export default Header; 